import { render, staticRenderFns } from "./UiFormSection.vue?vue&type=template&id=e7e73a08&"
import script from "./UiFormSection.vue?vue&type=script&lang=js&"
export * from "./UiFormSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports